import { cn } from '@/lib/cn';

export interface SearchEventRowProps {
  date: string;
  teams: string;
  breadcrumb: string;
  onSelect?: () => void;
  className?: string;
}

export function SearchEventRow({
  date,
  teams,
  breadcrumb,
  onSelect,
  className,
}: SearchEventRowProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'flex min-h-14 w-full flex-col items-start gap-1 bg-bg-surface px-3 py-2 text-left',
        'hover:bg-bg-elevated focus-visible:bg-bg-elevated focus-visible:outline-none',
        className,
      )}
    >
      <span className="w-full truncate text-[11px] text-text-secondary">{date}</span>
      <span className="w-full truncate text-[13px] font-bold text-text-primary">{teams}</span>
      <span className="w-full truncate text-[11px] text-text-secondary">{breadcrumb}</span>
    </button>
  );
}
